import React from 'react'
import ContentLoader from 'react-content-loader'

export const AiAssistantMessageSkeleton: React.FC<{ side: 'left' | 'right' }> = ({ side }) => {
  const isLeft = side === 'left';

  return (
    <div
      className={`d-flex w-100 mb-3 ${isLeft ? 'justify-content-start' : 'justify-content-end'}`}
    >
      {/* Circle skeleton for the avatar (left side only) */}
      {isLeft && (
        <ContentLoader
          speed={2}
          width={50}
          height={50}
          viewBox="0 0 50 50"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
          className="me-2"
        >
          <circle cx="25" cy="25" r="20" />
        </ContentLoader>
      )}

      {/* Rectangle skeleton for the message bubble */}
      <ContentLoader
        speed={2}
        width={180}
        height={40}
        viewBox="0 0 180 40"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="8" ry="8" width="180" height="40" />
      </ContentLoader>

      {/* Circle skeleton for the avatar (right side only) */}
      {!isLeft && (
        <ContentLoader
          speed={2}
          width={50}
          height={50}
          viewBox="0 0 50 50"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
          className="ms-2"
        >
          <circle cx="25" cy="25" r="20" />
        </ContentLoader>
      )}
    </div>
  );
};
